import { Controller } from "@hotwired/stimulus"
import { shouldActivateClickEvent } from "../../../utils/keyboardAccessibility"

export default class extends Controller {
  static targets = ["modal"]

  connect() {
    this.modalRoot = this.hasModalTarget ? this.modalTarget : null
    this.portalModal()
  }

  disconnect() {
    this.restoreModal()
  }

  open(event) {
    if (!this.shouldActivate(event)) return

    event.preventDefault()
    event.stopPropagation()

    const modalRoot = this.modalRoot || (this.hasModalTarget ? this.modalTarget : this.element)
    this.modalControllerFor(modalRoot)?.show(event)
  }

  shouldActivate(event) {
    return shouldActivateClickEvent(event)
  }

  modalControllerFor(modalRoot) {
    return this.application.getControllerForElementAndIdentifier(modalRoot, "railsui-modal")
  }

  portalModal() {
    const modal = this.modalRoot
    if (!modal || modal.dataset.portaled === "true") return

    if (modal.parentElement === document.body) {
      modal.dataset.portaled = "true"
      return
    }

    this.modalHome = document.createComment("teaching-point-modal-home")
    modal.before(this.modalHome)
    document.body.appendChild(modal)
    modal.dataset.portaled = "true"
  }

  restoreModal() {
    const modal = this.modalRoot
    if (!modal || !this.modalHome) return

    if (this.modalHome.isConnected && modal.isConnected) {
      this.modalHome.replaceWith(modal)
    } else if (modal.isConnected && modal.parentElement === document.body) {
      modal.remove()
    }

    if (this.modalHome.isConnected) this.modalHome.remove()
    delete modal.dataset.portaled
    this.modalHome = null
  }
}
